// Global tap haptics: a short vibration on every touch of an interactive
// element. Works on Android (navigator.vibrate); iOS Safari has no vibration
// API, so it silently no-ops there.
const INTERACTIVE =
  'button, a, input, select, label, [role="button"], .mobile-card-link, ' +
  '.mobile-card, .thumbnail, .swiper-slide, .category-pill, .filter-pill, ' +
  '.featured-card, .similar-product-card, option';

let initialized = false;

export function buzz(ms = 8) {
  try {
    if (navigator.vibrate) navigator.vibrate(ms);
  } catch {
    /* ignore */
  }
}

export function initGlobalHaptics() {
  if (initialized) return;
  initialized = true;

  document.addEventListener(
    'pointerdown',
    (e) => {
      if (e.pointerType !== 'touch') return;
      if (e.target?.closest?.(INTERACTIVE)) buzz(8);
    },
    { capture: true, passive: true }
  );
}
